import { globalData, globalConf } from "@olmokit/core/data";
import axios from 'axios';
import "./index.scss";

// //////////
// IMPORTANT:
// some events are intercepted and pushed 
// directly by the route or components js, 
// they are not described here
// //////////

/**
 * Component: Datalayer
 */

if (globalData.route == '404') {
  dataLayer.push({
    "event": "404"
  });
}

export function Datalayer() {
  console.log("Datalayer mounted.");
}

export function dataLayerForm(event, formData, formname, user, request) {
  dataLayer.push({
    ...formData,
    event: event,
    form: formname,
    user_type: user,
    request_type: request,
  });
}

export function salesforceCommunication(formData, formType, user, request) {
  const utmSource = localStorage.getItem('utm_source');
  formData['utmsource'] = utmSource;
  axios.post(globalConf.cmsApiUrl+'/'+globalConf.locale+'/salesforce/access', formData)
  .then(() => {
    console.log('salesforce done');
  })
  .catch((error) => {
    dataLayerForm("salesforce_error", formData, formType, user, request);
    console.log(error);
  });
}